module.exports = __webpack_public_path__ + "static/media/heart-black.3a879888.svg";